(function() {

  var html = document.documentElement;

  function getPreference() {
    try {
      var saved = localStorage.getItem('fp_theme');
      if (saved) return saved;
    } catch(e){}
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  function applyTheme(theme) {
    html.setAttribute('data-theme', theme);
    try { localStorage.setItem('fp_theme', theme); } catch(e){}
    var btn = document.getElementById('fp-dark-toggle');
    if (btn) {
      btn.innerHTML = theme === 'dark' ? '☀️ Light' : '🌙 Dark';
    }
    applyLogoForTheme(theme);
  }

  applyTheme(getPreference());

  var logoObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'data-theme') {
        var theme = document.documentElement.getAttribute('data-theme');
        var logo = document.querySelector('.header__heading-logo img, .header__heading img');
        if (logo) {
          logo.setAttribute('src', theme === 'dark'
            ? 'https://cdn.shopify.com/s/files/1/0752/9368/7948/files/FirstPass_Logo_w_.ca_No_BG.png?v=1774150261'
            : 'https://cdn.shopify.com/s/files/1/0752/9368/7948/files/FirstPass_Logo_w_.ca_BW_1.png?v=1774139331'
          );
        }
      }
    });
  });
  logoObserver.observe(document.documentElement, { attributes: true });

  function applyLogoForTheme(theme) {
    function swap() {
      var logo = document.querySelector(
        '.header__heading-logo-wrapper img, .header__heading-logo img, .header__heading img, sticky-header img, header img'
      );
      if (logo) {
        logo.setAttribute('src', theme === 'dark'
          ? 'https://cdn.shopify.com/s/files/1/0752/9368/7948/files/FirstPass_Logo_w_.ca_No_BG.png?v=1774150261'
          : 'https://cdn.shopify.com/s/files/1/0752/9368/7948/files/FirstPass_Logo_w_.ca_BW_1.png?v=1774139331'
        );
        logo.removeAttribute('srcset');
      } else {
        setTimeout(swap, 50);
      }
    }
    swap();
  }

  function injectToggle() {
    if (document.getElementById('fp-dark-toggle')) return;

    var btn = document.createElement('button');
    btn.id = 'fp-dark-toggle';
    btn.className = 'fp-dark-toggle';
    btn.setAttribute('aria-label', 'Toggle dark mode');
    var currentTheme = html.getAttribute('data-theme') || 'light';
    btn.innerHTML = currentTheme === 'dark' ? '☀️ Light' : '🌙 Dark';
    btn.addEventListener('click', function() {
      var current = html.getAttribute('data-theme');
      applyTheme(current === 'dark' ? 'light' : 'dark');
    });

    var headerIcons = document.querySelector('.header__icons');
    if (headerIcons) {
      headerIcons.insertBefore(btn, headerIcons.firstChild);
    }

    applyLogoForTheme(currentTheme);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectToggle);
  } else {
    injectToggle();
  }

})();
